module.exports = __webpack_public_path__ + "static/fonts/huakang.1ffb6dc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/huakang.ttf
// module id = p/5A
// module chunks = 1